"use client";
import { useEffect } from "react";
import { X } from "lucide-react";
import EditBasicProfileForm from "../molecules/EditBasicProfileForm";
import EditWorkExperienceForm from "../molecules/EditWorkExperienceForm";
import EditEducationForm from "../molecules/EditEducationForm";
import EditSalaryForm from "../molecules/EditSalaryForm";
import EditSkillForm from "../molecules/EditSkillForm";
import EditResumeForm from "../molecules/EditResumeForm";
import EditCertificateForm from "../molecules/EditCertificateForm";
import EditProjectForm from "../molecules/EditProjectForm";
import EditPreferenceForm from "../molecules/EditPreferenceForm";
import EditLanguageForm from "../molecules/EditLanguageForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  type: string;
  setWorkExperience?: any;
  workExperience?: any;
  setEducation?: any;
  education?: any;
  setBasicInformation?: any;
  basicInformation?: any;
  setSalary?: any;
  salary?: any;
  setSkill?: any;
  skill?: any;
  setResume?: any;
  resume?: any;
  setCertificate?: any;
  certificate?: any;
  setProject?: any;
  project?: any;
  preference?: any;
  setPreference?: any;
  setLanguage?: any;
  language?: any;
  lang?: any;
};

export default function EditProfileModal({
  isOpen,
  onClose,
  type,
  setWorkExperience,
  workExperience,
  setEducation,
  education,
  setBasicInformation,
  basicInformation,
  setSalary,
  salary,
  setSkill,
  skill,
  setResume,
  resume,
  setCertificate,
  certificate,
  setProject,
  project,
  setPreference,
  preference,
  setLanguage,
  language,
  lang
}: Props) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";   // kunci scroll
    } else {
      document.body.style.overflow = "";         // reset ke default
    }

    // Cleanup ketika komponen unmount
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);
  if (!isOpen) return null;


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center m-0">
      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* MODAL PANEL */}
      <div
        className="
          relative bg-white rounded-2xl shadow-lg animate-fadeIn
          w-full max-w-3xl max-h-[90vh]
          overflow-y-auto
          p-6
          mx-3
        "
      >
        {/* CLOSE BUTTON */}
        <button
          onClick={onClose}
          className="absolute right-5 top-5 text-gray-500 hover:text-gray-700"
        >
          <X size={20} />
        </button>

        {/* TITLE */}
        <h2 className="text-2xl font-semibold text-center mb-6 mt-2">
          {type === "basic" &&
            (lang === "id" ? "Edit Profil" : "Edit Profile")}

          {type === "work" &&
            (lang === "id" ? "Edit Pengalaman Kerja" : "Edit Work Experience")}

          {type === "education" &&
            (lang === "id" ? "Edit Pendidikan" : "Edit Education")}

          {type === "salary" &&
            (lang === "id" ? "Edit Informasi Gaji" : "Edit Salary Information")}

          {type === "skill" &&
            (lang === "id" ? "Edit Keahlian" : "Edit Skill")}

          {type === "preferences" &&
            (lang === "id" ? "Preferensi Pekerjaan" : "Job Preferences")}

          {type === "resume" &&
            (lang === "id" ? "Edit CV" : "Edit Resume")}

          {type === "certificate" &&
            (lang === "id" ? "Edit Sertifikat" : "Edit Certificate")}

          {type === "project" &&
            (lang === "id" ? "Edit Proyek" : "Edit Project")}

          {type === "language" &&
            (lang === "id" ? "Edit Bahasa" : "Edit Language")}
        </h2>


        {/* SWITCH FORM */}
        {type === "basic" && (
          <EditBasicProfileForm
            onClose={onClose}
            setBasicInformation={setBasicInformation}
            defaultData={basicInformation}
          />
        )}

        {type === "work" && (
          <EditWorkExperienceForm
            onClose={onClose}
            setWorkExperience={setWorkExperience}
            defaultData={workExperience}
          />
        )}
        {type === "education" && (
          <EditEducationForm
            onClose={onClose}
            setEducation={setEducation}
            defaultData={education}
          />
        )}
        {type === "salary" && (
          <EditSalaryForm
            onClose={onClose}
            setSalary={setSalary}
            defaultData={salary}
          />
        )}
        {type === "skill" && (
          <EditSkillForm
            onClose={onClose}
            setSkill={setSkill}
            defaultData={skill}
          />
        )}
        {type === "certificate" && (
          <EditCertificateForm
            onClose={onClose}
            setCertificate={setCertificate}
            defaultData={certificate}
          />
        )}
        {type === "resume" && (
          <EditResumeForm
            onClose={onClose}
            setResume={setResume}
            defaultData={resume}
          />
        )}
        {type === "project" && (
          <EditProjectForm
            onClose={onClose}
            setProject={setProject}
            defaultData={project}
          />
        )}
        {type === "preference" && (
          <EditPreferenceForm
            onClose={onClose}
            setPreference={setPreference}
            defaultData={preference}
          />
        )}
        {type === "language" && (
          <EditLanguageForm
            onClose={onClose}
            setLanguage={setLanguage}
            defaultData={language}
          />
        )}
      </div>
    </div>
  );
}
